import { PipeObject, Token, Replacement } from '../types';

const imageRegex = /!\[(?<alt>[^\]]*)\]\((?<url>.*?)(?=\"|\))(?:\"(?<title>.*)\")?\)/;

export const InlineImage = () => {
  return ({ input, lex, data }: PipeObject) => {
    let obj: Token;
    let replacements: Replacement[] = [];
    while ((obj = lex.next())) {
      if (obj.token === 'image_link') {
        const value = input.substring(obj.begin, obj.end + 1).trim();
        if (value) {
          const match = value.match(imageRegex);
          if (match && match.length > 0) {
            replacements.push({
              searchValue: value,
              replaceValue: `<img src="${match?.groups?.url.trim()}" alt="${
                match?.groups?.alt || ''
              }" title="${
                match?.groups?.title || ''
              }" style="max-width:93%; width:auto;" />`,
            });
          }
        }
      }
    }

    for (const rep of replacements) {
      input = input.replace(rep.searchValue, rep.replaceValue);
    }

    return { input, lex, data };
  };
};
